module.exports = __webpack_public_path__ + "img/GBP.9c12b5b5.svg";